import { createActions, createAction } from 'redux-actions';
import { request } from '../../services';

const {
  requestAppointmentRequest,
  requestAppointmentSuccess,
  requestAppointmentFailure,
} = createActions({
  REQUEST_APPOINTMENT_SUCCESS: (json, appointmentId) => ({
    appointment: json.appointment,
    appointmentId,
  }),
}, 'REQUEST_APPOINTMENT_REQUEST', 'REQUEST_APPOINTMENT_FAILURE');

export function requestAppointment(appointmentId) {
  return (dispatch) => {
    dispatch(requestAppointmentRequest());

    return request(`appointments/${appointmentId}`)
      .then(({ json }) =>
        dispatch(requestAppointmentSuccess(json, appointmentId)),
      )
      .catch(error => dispatch(requestAppointmentFailure(error)));
  };
}

const {
  phaseAppointmentCreateRequest,
  phaseAppointmentCreateSuccess,
  phaseAppointmentCreateFailure,
} = createActions({
  PHASE_APPOINTMENT_CREATE_SUCCESS: json => ({
    appointment: json.appointment,
    phase: json.appointment.phase,
    inspection_required: (json.meta && json.meta.inspection_required) || false,
  }),
}, 'PHASE_APPOINTMENT_CREATE_REQUEST', 'PHASE_APPOINTMENT_CREATE_FAILURE');

export function createPhaseAppointment(phaseID, params, ssData, event = {}) {
  return (dispatch) => {
    dispatch(phaseAppointmentCreateRequest());
    const { source, ignoredWarnings } = ssData;
    const req = { method: 'POST', body: { appointment: params, source, ignored_warnings: ignoredWarnings, event } };
    return request(`phases/${phaseID}/appointments`, req)
      .then(({ json }) => dispatch(phaseAppointmentCreateSuccess(json)))
      .catch(error => dispatch(phaseAppointmentCreateFailure(error)));
  };
}

const {
  phaseAppointmentEditRequest,
  phaseAppointmentEditSuccess,
  phaseAppointmentEditFailure,
} = createActions({
  PHASE_APPOINTMENT_EDIT_SUCCESS: json => ({
    appointment: json.appointment,
    phase: json.appointment.phase,
    inspection_required: (json.meta && json.meta.inspection_required) || false,
  }),
}, 'PHASE_APPOINTMENT_EDIT_REQUEST', 'PHASE_APPOINTMENT_EDIT_FAILURE');

export function editPhaseAppointment(apptID, phaseID, params, ssData, event = {}) {
  return (dispatch) => {
    dispatch(phaseAppointmentEditRequest());
    const { source, ignoredWarnings } = ssData;
    const req = { method: 'PUT', body: { appointment: params, source, ignored_warnings: ignoredWarnings, event } };
    return request(`phases/${phaseID}/appointments/${apptID}`, req)
      .then(({ json }) => dispatch(phaseAppointmentEditSuccess(json)))
      .catch(error => dispatch(phaseAppointmentEditFailure(error)));
  };
}

const {
  phaseAppointmentDeleteRequest,
  phaseAppointmentDeleteSuccess,
  phaseAppointmentDeleteFailure,
} = createActions({
  PHASE_APPOINTMENT_DELETE_SUCCESS: (appointmentID, json) => ({
    appointmentID,
    event: json.event,
  }),
}, 'PHASE_APPOINTMENT_DELETE_REQUEST', 'PHASE_APPOINTMENT_DELETE_FAILURE');

export function deletePhaseAppointment(appointmentID, event) {
  return (dispatch) => {
    dispatch(phaseAppointmentDeleteRequest());

    const req = { method: 'DELETE', body: { event } };
    return request(`appointments/${appointmentID}`, req)
      .then(({ json }) => dispatch(phaseAppointmentDeleteSuccess(appointmentID, json)))
      .catch(error => dispatch(phaseAppointmentDeleteFailure(error)));
  };
}

const {
  phaseAppointmentAddValidation,
} = createActions('PHASE_APPOINTMENT_ADD_VALIDATION');

export function addValidationErrors(errors) {
  return dispatch => dispatch(phaseAppointmentAddValidation({ errors }));
}

export const phaseAppointmentClearValidation =
  createAction('PHASE_APPOINTMENT_CLEAR_VALIDATION');



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/appointments.js